// we need the callback function for vidible videos available before the video loads or the onLoad event won't trigger.
function vidibleOnPlayerReady(player) {
    var $playerDiv = $(player.div);
    var $topVideos = $playerDiv.closest('.top-videos');
    var requiredHeightSync = true;

    if ($topVideos.length) {
        requiredHeightSync = false;
        $topVideos.topVideos('hookVidible', player);
    } else if ($playerDiv.hasClass('vidible-b-page-video')) {
        player.addEventListener(vidible.VIDEO_END, function() {
            var published_date = $(".vdb_player").data("published");
            var videovertical = $(".vdb_player").data("videovertical");
            get_next_video(published_date, videovertical);
        });
    }

    if (requiredHeightSync) {
        player.addEventListener(vidible.PLAYER_READY, function(e) {
            refreshVideoHeight(player.getPlayerContainer().offsetWidth, player.getPlayerContainer().offsetHeight);
        });
    }

    vidibleFixLabels(player);
}

function vidibleOnPlayerReadyLoop(player) {
    // Special report needs responsive players so the fix shouldn't be used
    if(!$(player.div).hasClass('vidible-b-page-special')) {
        player.addEventListener(vidible.PLAYER_READY, function(e) {
            refreshVideoHeight(e.player);
        });
    }
    player.addEventListener(vidible.VIDEO_TIMEUPDATE, function(e) {
    	if(e.data.playheadTime + 0.2 > e.data.duration) {
    		player.seekTo(0);
    	}
    });
    vidibleFixLabels(player);
}
function refreshVideoHeight(width, height) {
    //UK uses a square player with fixed height and width (400x400), that setting makes the video totally unresponsive so 100% padding bottom in styles doesn't work on this case, we need to treat it differently
    var isSquare = width === height;
    var contentHeight = isSquare ? height : '';

    $('.video-entry__content-main .embed-container, .top-media__video').css('padding-bottom', contentHeight);
}

function vidibleFixLabels(player) {
    player.addEventListener(vidible.PLAYER_READY, function(e) {
        var label = $('.vdb_player').data('aria-label');
        if (label) {
            $('.vdb_player').find('iframe').attr('aria-label', label);
        }
    });
}
